import type { ISerialize } from '@/objects/ISerialize';
import { GetDynamicReportParameterDataResponseLine } from './GetDynamicReportParameterDataResponseLine';

export class GetDynamicReportParameterDataResponse implements ISerialize {
    public ParameterData: GetDynamicReportParameterDataResponseLine[];

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { ParameterData?: GetDynamicReportParameterDataResponseLine[] }) {
        this.ParameterData = values.ParameterData ?? [];
    }

    public serialize(): string {
        return '{' + `"ParameterData": [ ${this.ParameterData.map((x) => (!x ? null : x?.serialize()))} ]` + '}';
    }

    /**
     * Creates an instance of GetDynamicReportParameterDataResponse from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        ParameterData?: GetDynamicReportParameterDataResponseLine[];
    }): GetDynamicReportParameterDataResponse {
        return new GetDynamicReportParameterDataResponse(values);
    }

    public static _FromServerJson(json: any): GetDynamicReportParameterDataResponse {
        return new GetDynamicReportParameterDataResponse({
            ParameterData: json.ParameterData?.map((x: any) => GetDynamicReportParameterDataResponseLine._FromServerJson(x)),
        });
    }

    /**
     * Creates an instance of GetDynamicReportParameterDataResponse from another instance of GetDynamicReportParameterDataResponse.
     * @param other The GetDynamicReportParameterDataResponse you want to clone
     * @returns A cloned GetDynamicReportParameterDataResponse
     */
    public static FromOther(other: GetDynamicReportParameterDataResponse): GetDynamicReportParameterDataResponse {
        return GetDynamicReportParameterDataResponse._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return GetDynamicReportParameterDataResponse.FromOther(this);
    }

    static NAME_OF_CLASS = 'GetDynamicReportParameterDataResponse';
}
